export function translateAddZoomToMap(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  rules.push({
    category: "recommender",
    description: `Add zoom`,
    specifier: { role: "interaction" },
    action: "add",
    option: {
      interaction: "zoompan"
    }
  });
  return rules;
}

export function translateAddContextToBar(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  rules.push({
    category: "recommender",
    description: `Add context`,
    specifier: { role: "interaction" },
    action: "add",
    option: {
      interaction: "context"
    }
  });
  return rules;
}